import { computed, Signal, WritableSignal } from '@angular/core';
import { SecurityTaxResultItemForm } from './security-tax-result-item-form';

export class SecurityTaxResultItemReview {
  taxResultTypeId!: number;
  securityTaxResultItemId!: number;
  title!: string;
  items!: WritableSignal<SecurityTaxResultItemForm[]>;
  initialSize: number = 0;

  hasErrors: Signal<boolean> = computed((): boolean => {
    return this.items().some(item => item.isInvalid());
  });

  hasChanges: Signal<boolean> = computed(() => {
    return (
      this.items().some(item => item.hasChanges()) ||
      this.items().length !== this.initialSize
    );
  });

  hasItems: Signal<boolean> = computed((): boolean => {
    return this.items() && this.items().length > 0;
  });

  hasDuplicatedValues: Signal<boolean> = computed((): boolean => {
    return this.items().some(item => item.hasDuplicatedValues());
  });
}
